import { constructFrom } from "./constructFrom.js";
import { toDate } from "./toDate.js";

/**
 *
 */

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function addMonths(date, amount, options) {
  const _date = toDate(date, options?.in);
  if (isNaN(amount)) return constructFrom(options?.in || date, NaN);
  if (!amount) {
    /*                                                                       */
    return _date;
  }
  const dayOfMonth = _date.getDate();

  /*                                                                          */
  /*                                                                         */
  /*                                                                          */
  /*                                                                       */
  /*                                                                           */
  /*                                                                       */
  /*                                                                       */
  /*     */
  const endOfDesiredMonth = constructFrom(options?.in || date, _date.getTime());
  endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
  const daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    /*                                                                      */
    /*              */
    return endOfDesiredMonth;
  } else {
    /*                                                                        */
    /*                                                                     */
    /*                                                                        */
    /*                                                                       */
    /*                                                                      */
    /*                                                                    */
    /*                                          */
    _date.setFullYear(
      endOfDesiredMonth.getFullYear(),
      endOfDesiredMonth.getMonth(),
      dayOfMonth,
    );
    return _date;
  }
}

/*                                */
export default addMonths;
